import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService} from '../../shared/Services/authentication.service';
import {Helper} from '../../helpers/helper.service';
import {Router} from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {
  public username: string;
  constructor(
    private auth: AuthenticationService, 
    private helper: Helper, 
    private router: Router,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
    
    this.helper.removeHideRecaptchaBadgeClassToBody();
  }

  submit() {
    this.reCaptchaV3Service.execute('login').subscribe((token: string) => {
      this.auth.requestForgotPassword(this.username, token).subscribe(() => {
        this.router.navigateByUrl('/success-forgot-password');
      });
    }, () => {
      this.helper.popMessageDialog(
        this.translateService.instant("errors.recaptcha.title"),
        this.translateService.instant("errors.recaptcha.failed"),
        "error",
        false,
      )
    });
  }

  ngOnDestroy(): void {
    this.helper.addHideRecaptchaBadgeClassToBody();
  }
}
